import Icon from "@/components/Icon";
import { chakra, Box, ChakraProps, Flex, Spacer, Text } from "@chakra-ui/react";
import { ReactComponent as selectedIcon } from "@/assets/icons/vip_selected.svg";
import { isNaN } from "lodash";

interface CardProps {
  title: string;
  oldPrice: string;
  curPrice: string;
  selected?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  unitInfo?: string;
  periodPrice?: string;
}

const goldGradient = `linear-gradient(90deg, #F0BF68, #F9E5AE);`;
const defaultBgColor = "#404040";
const goldBorder: ChakraProps = {
  _before: {
    content: "''",
    bg: goldGradient,
    pos: "absolute",
    left: 0,
    top: 0,
  },
  bg: goldGradient,
};

export default function NewPriceCard(props: CardProps) {
  const {
    title,
    oldPrice,
    curPrice,
    selected = false,
    className,
    onClick,
    unitInfo = "",
    periodPrice = "",
  } = props;
  const validOldPrice = !isNaN(parseInt(oldPrice)) && oldPrice !== "0";
  return (
    <Flex
      width="100%"
      h="127px"
      pos="relative"
      rounded="6px"
      bg={defaultBgColor}
      border="2px solid transparent"
      cursor="pointer"
      className={className}
      onClick={onClick}
      {...(selected ? { ...goldBorder } : {})}
    >
      <Flex
        w="100%"
        p="16px"
        pos="relative"
        rounded="4px"
        bg={selected ? "#2D2D2D" : defaultBgColor}
      >
        <Box maxW="160px">
          <Text color="#DCDCDC" fontWeight={600} fontSize="14px" lineHeight="22px">
            {title}
          </Text>
          <Text
            mt="8px"
            color="#999999"
            textDecor={validOldPrice ? "line-through" : "none"}
            fontSize="10px"
            lineHeight="10px"
          >
            {validOldPrice ? `原价¥${oldPrice}` : oldPrice === "0" ? "\u00A0" : oldPrice}
          </Text>
          <Text mt="8px" whiteSpace="nowrap">
            <chakra.span
              bg={selected ? goldGradient : "#36C19E"}
              bgClip="text"
              fontWeight={600}
              fontSize="12px"
            >
              ¥
            </chakra.span>
            <chakra.span
              bg={selected ? goldGradient : "#36C19E"}
              bgClip="text"
              fontWeight={600}
              fontSize="24px"
              lineHeight="24px"
            >
              {curPrice}
            </chakra.span>
            <chakra.span
              bg={selected ? goldGradient : "#36C19E"}
              bgClip="text"
              verticalAlign="text-bottom"
              fontWeight={600}
              fontSize="12px"
            >
              {periodPrice}
            </chakra.span>
          </Text>
          <Text
            fontSize="12px"
            color="#999999"
            verticalAlign="0.3em"
            whiteSpace="nowrap"
            fontWeight={400}
          >
            {unitInfo}
          </Text>
        </Box>
        <Spacer />
        <Flex align="center" justify="flex-end">
          {selected ? (
            <Icon squared={false} attrs={{ width: 20, height: 20 }} svg={selectedIcon} />
          ) : (
            <Box w="20px" h="20px" />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}
